import { render, staticRenderFns } from "./AppDelete.vue?vue&type=template&id=11bf8fa8&scoped=true&"
import script from "./AppDelete.vue?vue&type=script&lang=js&"
export * from "./AppDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bf8fa8",
  null
  
)

export default component.exports